import { BrandedErrorPage } from '@/components/common/BrandedErrorPage';

export default function NotFound() {
  return (
    <BrandedErrorPage
      code="404"
      title="Page not found"
      message="The page you're looking for doesn't exist, or may have moved."
    />
  );
}
